export default __webpack_public_path__ + "static/media/adaptation_keyboard_navigation_enabling.3a98e095.svg";